<template>
    <div class="smr-select">
        <div class="smr-select__placeholder" v-if="data === '' || data.length === 0" v-html="placeholder"></div>
        <el-select v-model="data" :placeholder="''" :popper-class="popperClass" :multiple="multiple" :clearable="clearable" @change="selectChangeHandler" @visible-change="visibleChangeHandler">
            <template v-if="hasGroups">
                <el-option-group v-for="(group, index) in options" :key="index" :label="group.title">
                   <el-option
                        v-for="option in group.options"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value">
                        <Icon class="smr-select__check" :width="11" :height="11" v-if="multiple">
                            <IconCheckSmall/>
                        </Icon>
                        {{ option.label }}
                    </el-option> 
                </el-option-group>
            </template>
            <template v-else>
                <el-option
                    v-for="option in options"
                    :key="option.value"
                    :label="option.label"
                    :value="option.value">
                    <Icon class="smr-select__check" :width="11" :height="11" v-if="multiple">
                        <IconCheckSmall/>
                    </Icon>
                    {{ option.label }}
                </el-option>
            </template>
        </el-select>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue'
import IconCheckSmall from '@/components/icons/IconCheckSmall.vue'
import { trackEvent, trackGa4Event } from '@/utils/tracking'
export default {
    components: {
        Icon,
        IconCheckSmall
    },
    props: {
        multiple: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Wählen'
        },
        options: {
            type: Array,
            default: () => []
        },
        value: {
            type: [Array, String],
            default: ''
        },
        outputArray: {
            type: Boolean,
            default: false
        },
        additionalPopperClass: {
            type: [String, Boolean],
            default: false
        },
        trackingData: {
            type: [Object, Boolean],
            default: false,
        },
        trackingDataGa4Event: {
            type: [String, Boolean],
            default: false,
        },
        hasGroups: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            data: '',
            trackingDataValue: '',
        }
    },
    computed: {
        popperClass() {
            return 'smr-select__popper smr-select__popper--' + (this.multiple ? 'multiple' : 'single') + (this.hasGroups ? ' smr-select__popper--has-groups' : '') + (this.additionalPopperClass ? ` ${this.additionalPopperClass}` : '');
        }
    },
    created() {
        this.setInitialValue();
    },
    watch: {
        value() {
            this.setInitialValue();
        }
    },
    methods: {
        selectChangeHandler() {
            this.emitChange();
        },
        visibleChangeHandler(value) {
            this.$emit('visibleChange', value)
        },
        setInitialValue() {
            if(!this.value) return false;
            let value;
            if(this.outputArray && Array.isArray(this.value) && !this.multiple) {
                value = this.value[0];
            } else {
                value = this.value;
            }
            this.data = value;
        },
        emitChange() {
            let output = this.data;
            let countryValues = [];
            if(this.outputArray && !Array.isArray(output)) {
                output = [output];
            }
            this.$emit('change', output);
            if(this.trackingData) {
                let trackingDataLabel = '';
                if(this.trackingData.category === 'Stations' && this.value === 'ARRIVAL') {
                    trackingDataLabel = 'Departure Time'
                    this.trackingDataValue = 'departure_time'
                } else if(this.trackingData.category === 'Stations' && this.value === 'DEPARTURE') {
                    trackingDataLabel = 'Arrival Time';
                    this.trackingDataValue = 'arrival_time'
                } else if(this.trackingData.label) {
                    output.forEach(item => {
                        let label = this.options.filter(option => option.value === item)[0].label;
                        countryValues.push(label);
                    });

                    let countryName = '';
                    countryValues.forEach(country => {
                        countryName += ' ' + country;
                    })
                    trackingDataLabel = this.trackingData.label + countryName;
                    this.trackingDataValue = `${this.trackingData.value}-${countryName.replace(/ /g, "-").toLowerCase().substring(1)}`;
                }
                else {
                    trackingDataLabel = this.data.toLowerCase();
                    this.trackingDataValue = this.data.toLowerCase();
                }
                trackEvent({ category: this.trackingData.category, action: this.trackingData.action, label: trackingDataLabel })
                if(this.trackingData.category) {
                    let ga4Parameter1Name = '';
                    this.trackingData.category === 'Stations' ? ga4Parameter1Name = 'order' : ga4Parameter1Name = 'options';
                    trackGa4Event({ga4Parameter1Name: ga4Parameter1Name, ga4Parameter1Value: this.trackingData.prefix ? this.trackingData.prefix + this.trackingDataValue : this.trackingDataValue, ga4Event: this.trackingData.name ? this.trackingData.name : this.trackingData.category.replace(/ /g, "_").toLowerCase()})
                } else {
                    trackGa4Event({ga4Parameter1Name: 'options', ga4Parameter1Value: this.trackingDataValue, ga4Parameter2Name: 'tab', ga4Parameter2Value: this.trackingData.value2, ga4Event: this.trackingDataGa4Event})
                }
            }
        }
 
    }
}
</script>

<style lang="scss">
.smr-select {
    $block: &;
    position: relative;

    &__placeholder {
        position: absolute;
        top: 50%;
        left: 0;
        transform: translateY(-50%);
        color: $color-black-05;
        font-size: 15px;
        line-height: 1.37;
        z-index: 1;
        padding: 0 35px 0 15px;
        pointer-events: none;
    }

    &__option {
        &__icon {
            .selected & {
                &::after {
                    display: block;
                }
            }
        }
    }
    .el-select {
        display: block;
        &__tags {
            padding: 0 8px;
        }
        &:hover {
            .el-input {
                &__inner {
                    border-color: $color-black-02;
                }
                &.is-focus {
                    .el-input {
                        &__inner {
                            border-color: $color-yellow;
                        }
                    }
                }
            }
        }
    }
    .el-input {
        &__inner {
            border-color: $color-black-005;
            border-radius: 8px;
            height: 44px;
            line-height: 44px;
            color: $color-black;
            font-size: 15px;
            @include mq($until: tablet) {
                height: 54px;
            }
            &::placeholder {
                color: $color-black;
                opacity: 0.5;
            }
            &:focus {
                border-color: $color-yellow;
            }
        }
        &__suffix {
            right: 10px;
        }
        .el-select {
            &__caret {
                color: $color-grey;
                font-size: 16px;
                font-weight: bold;
            }
        }
        &.is-focus {
            .el-input__inner {
                border-color: $color-yellow;
            }   
        }
    }
    &__popper {
        border-radius: 8px;
        box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.2);
        border: solid 1px rgba(88, 88, 88, 0.2);
        z-index: 999999 !important;
        &--single {
            .el-select-dropdown {
                &__item {
                    &::before {
                        border-radius: 100%;
                    }
                    &::after {
                        content: '';
                        position: absolute;
                        left: 5px;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 7px;
                        height: 7px;
                        border-radius: 100%;
                        background-color: white;
                    }
                }
            }
        }
        &--multiple {
            .el-select-dropdown {
                &__wrap {
                    max-height: 440px;
                }
                &__item {
                    &::before {
                        border-radius: 3px;
                    }
                    &::after {
                        color: white;
                        left: 3px;
                        display: none;
                    }
                    
                }
            }
        }
        &--has-groups {
            .el-select-dropdown {
                &__list {
                    column-count: 1 !important;
                }
            }
        }
        &.el-popper[x-placement^=bottom] {
            margin-top: 6px;
        }
        .popper__arrow {
            display: none;
        }
        .el-select-dropdown {
            &__list {
                padding: 0 16px;
                @include mq(tablet) {
                    column-count: 2;
                    column-gap: 0;
                }
            }
            &__item {
                position: relative;
                font-size: 15px;
                color: $color-black;
                padding: 3px 20px 3px 32px;
                height: auto;
                border-bottom: 1px solid $color-black-005;
                break-inside: avoid;
                display: block;
                &::before {
                    content: '';
                    transition: border-color 0.15s;
                    position: absolute;
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 17px;
                    height: 17px;
                    border: 2px solid $color-grey;
                }
                &.selected {
                    font-weight: $font-weight-regular;
                    color: $color-black !important;
                    &::before {
                        background-color: $color-blue-light;
                        border-width: 0;
                    }
                    #{$block} {
                        &__check {
                            display: block;
                        }
                    }
                }
                &.hover,
                &.selected.hover {
                    background-color: transparent !important;
                    &::before {
                        border-color: $color-black;
                    }
                }
                #{$block} {
                    &__check {
                        position: absolute;
                        left: 3px;
                        top: 50%;
                        transform: translateY(-50%);
                        color: white;
                        display: none;
                    }
                }
                
            }
        }
        .el-select-group {
             @include mq(tablet) {
                column-count: 2;
                column-gap: 0;
            }
            &__title {
                padding: 8px 0;
                line-height: 22px;
                color: $color-black-05;
                font-size: 12px;
            }
            &__wrap {
                padding: 0;
                margin-bottom: 8px;
                &:after {
                    content: none;
                }
            }
        }
    }
    .el-tag {
        border: none;
        background-color: $color-yellow;
        font-weight: $font-weight-medium;
        color: $color-black;
        &--small {
            height: 28px;
            padding: 0 13px;
            line-height: 29px;
            border-radius: 28px;
        }
        &__close {
            &.el-icon-close{
                background-color: transparent;
                color: $color-black;
                transform: none;
                right: -4px;
                font-weight: bold;
                line-height: 18px;
                font-size: 17px;
                width: 20px;
                height: 20px;
                &:hover {
                    background-color: transparent;
                    color: $color-black;
                }
            }
        }
    }
}
</style>